const CACHE = {
  sessionToken: null as google.maps.places.AutocompleteSessionToken | null,
  timeout: null as number | null,
};

export function expireGooglePlacesSessionToken(
  sessionToken?: google.maps.places.AutocompleteSessionToken,
) {
  if (
    !CACHE.sessionToken ||
    (sessionToken && sessionToken !== CACHE.sessionToken)
  ) {
    return;
  } else if (CACHE.timeout) {
    window.clearTimeout(CACHE.timeout);
  }

  CACHE.sessionToken = null;
  CACHE.timeout = null;
}

export function getGooglePlacesSessionToken(
  canGenerate: true,
): google.maps.places.AutocompleteSessionToken;
export function getGooglePlacesSessionToken(
  canGenerate?: false,
): google.maps.places.AutocompleteSessionToken | null;
export function getGooglePlacesSessionToken(
  canGenerate = false,
): google.maps.places.AutocompleteSessionToken | null {
  if (CACHE.sessionToken !== null) {
    return CACHE.sessionToken;
  } else if (!canGenerate) {
    return null;
  }

  CACHE.sessionToken = new google.maps.places.AutocompleteSessionToken();
  // According to the official docs, a session token expires a few minutes
  // after the beginning of a session:
  // https://developers.google.com/maps/documentation/places/web-service/session-tokens#example.
  // Therefore, expire it at the shortest "a few minutes" possible (2m), to
  // avoid being billed for each request if Google expires it.
  CACHE.timeout = window.setTimeout(expireGooglePlacesSessionToken, 120000);

  return CACHE.sessionToken;
}
